import { render, staticRenderFns } from "./OutfitSharingButton.vue?vue&type=template&id=0707e49b&scoped=true&"
import script from "./OutfitSharingButton.vue?vue&type=script&lang=js&"
export * from "./OutfitSharingButton.vue?vue&type=script&lang=js&"
import style0 from "./OutfitSharingButton.vue?vue&type=style&index=0&id=0707e49b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0707e49b",
  null
  
)

export default component.exports